import { Box } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { withNavbar } from '../../app/layout/HOC';
import { useStore } from '../../app/stores/store';
import AppFooter from '../footer/AppFooter';
import HomePageComponent from './HomePageComponent';

function Home() {
    const { appDataStore } = useStore();
    const { loadLoginData, loginAppData } = appDataStore;

    useEffect(() => {
        if (!loginAppData) {
            loadLoginData();
        }
    }, [loginAppData, loadLoginData])

    return (
        <Box sx={{ flexGrow: 1 }}>
            <HomePageComponent />
            <AppFooter />
        </Box >
    )
}


const HomePage = withNavbar(observer(Home));

export default HomePage;